// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sLEO5","col":"styles_col__1aD_s","actions":"styles_actions__2S9C-","conflict":"styles_conflict__2uXtp"};